var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStratIntegrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9808 38.483L37.4219 41.1955",
    stroke: "#07143F",
    strokeWidth: 1.29412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.902 25.8802L32.5039 28.5029C31.5133 28.8929 30.4105 28.8864 29.4245 28.4848C28.4386 28.0831 27.6452 27.3171 27.2091 26.3459C26.773 25.3747 26.7277 24.2728 27.0826 23.2691C27.4375 22.2653 28.1653 21.4368 29.115 20.9556L35.5097 17.8497C36.205 17.502 36.9639 17.2997 37.74 17.2552C38.5161 17.2107 39.2931 17.3249 40.0236 17.5909L51.6983 22.0565",
    stroke: "#07143F",
    strokeWidth: 1.29412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0195 41.4097H17.8509L25.8917 47.5214C26.297 47.9759 26.8622 48.2563 27.4693 48.3039C28.0764 48.3515 28.6784 48.1626 29.1495 47.7768L41.228 38.0898C41.7034 37.6989 42.0074 37.1378 42.0751 36.526C42.1428 35.9142 41.9688 35.3002 41.5903 34.8148L34.9575 27.5056",
    stroke: "#07143F",
    strokeWidth: 1.29412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5835 21.3076L27.7208 20.5967C27.0273 20.0854 26.2149 19.7597 25.3603 19.6504C24.5057 19.5411 23.6374 19.6518 22.8376 19.9721L13.0195 24.1547",
    stroke: "#07143F",
    strokeWidth: 1.29412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 43.1352C2.6665 43.5928 2.8483 44.0317 3.17189 44.3553C3.49548 44.6789 3.93437 44.8607 4.392 44.8607H9.56849C10.4838 44.8607 11.3615 44.4971 12.0087 43.8499C12.6559 43.2027 13.0195 42.325 13.0195 41.4097V24.1547C13.0195 23.2395 12.6559 22.3617 12.0087 21.7145C11.3615 21.0673 10.4838 20.7037 9.56849 20.7037H4.392C3.93437 20.7037 3.49548 20.8855 3.17189 21.2091C2.8483 21.5327 2.6665 21.9716 2.6665 22.4292V43.1352Z",
    fill: "#D5DEFF",
    stroke: "#07143F",
    strokeWidth: 1.29412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 43.1352C61.3334 43.5928 61.1517 44.0317 60.8281 44.3553C60.5045 44.6789 60.0656 44.8607 59.608 44.8607H54.4315C53.5162 44.8607 52.6384 44.4971 51.9912 43.8499C51.3441 43.2027 50.9805 42.325 50.9805 41.4097V24.1547C50.9805 23.2395 51.3441 22.3617 51.9912 21.7145C52.6384 21.0673 53.5162 20.7037 54.4315 20.7037H59.608C60.0656 20.7037 60.5045 20.8855 60.8281 21.2091C61.1517 21.5327 61.3334 21.9716 61.3334 22.4292V43.1352Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeWidth: 1.29412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratIntegrity);
export default __webpack_public_path__ + "static/media/strat_integrity.9247dbfea60e56c854384c26079067f1.svg";
export { ForwardRef as ReactComponent };